import * as splitConstants from './split-constants'

// All local splits are 'on' or 'off' unless otherwise specified
export default {
  [splitConstants.API_KEY_MANAGEMENT]: 'on',
  [splitConstants.OAUTH_CLIENT_CRED_MGMT]: 'on',
  [splitConstants.KBP_BRANDS_QR_CODE]: 'off',
  [splitConstants.KBP_BRANDS_BYPASS_EMAIL]: 'off',
  [splitConstants.ORDER_SETTINGS]: 'on',
  [splitConstants.POR_1968_RG_REFERRAL_PROGRAM]: 'off',
  [splitConstants.QUALTRICS_SPLIT]: 'on',
  [splitConstants.REWARD_HISTORY]: 'off',
  [splitConstants.RG_4306_RG_ROP_UPLOAD_STATUS]: 'on',
  [splitConstants.RG_5459_VIEW_LINE_ITEMS_TAB]: 'on',
  [splitConstants.RG_ACH_DRAW]: 'on',
  [splitConstants.RG_ACH_REDESIGN]: 'off',
  [splitConstants.RG_BULK_ORDER_LARGER_RAW_FILE_SIZE]: 'on',
  [splitConstants.RG_BULK_ORDER_LIMITS]: 'off',
  [splitConstants.RG_CANCEL]: 'on',
  [splitConstants.RG_7504_REISSUE_EXPIRED_PROMO_LINK_PERMISSION]: 'on',
  [splitConstants.RG_DOWNLOAD_LINE_ITEMS]: 'on',
  [splitConstants.RG_FREEZE]: 'on',
  [splitConstants.RG_FUNDING_NOTIFICATIONS]: 'off',
  [splitConstants.RG_ORDER_HISTORY_TYPE]: 'off',
  [splitConstants.RG_ORDER_HISTORY_TYPE]: 'off',
  [splitConstants.RG_PERSONALIZATION_TO_FROM_SEARCH]: 'on',
  [splitConstants.RG_RECIPE_ENGINE_ASYNC_ORDERING]: 'on',
  [splitConstants.RG_RECIPIENTS_WHITELIST_FEATURE]: 'off',
  [splitConstants.RG_SAML_SSO_UI]: 'on',
  [splitConstants.WYNDHAM_CUSTOM_FIELDS]: 'off',
  [splitConstants.RG_SHOW_BULK_RESEND]: 'on',
  [splitConstants.RG_SELF_SIGNUP]: 'on',
  [splitConstants.RG_AUTH0_LOGIN]: 'on',
  [splitConstants.RG_INCREASED_ORDER_HISTORY_PAGE_SIZE]: 'control',
  [splitConstants.RG_ORDER_DIALOG]: 'off',
  [splitConstants.RG_7028_PROMO_LINK_EXPIRATION_HISTORY]: 'on',
  [splitConstants.RG_7080_TANGO_COMPANION_APP]: 'on',
  [splitConstants.RG_7198_REMOVE_403_IGNORE_LIST]: 'on',
  [splitConstants.RG_EASY_USE_CASE]: 'on',
  [splitConstants.RG_7282_TANGO_PRODUCT_OFFERINGS]: 'on',
  [splitConstants.RG_7482_TANGO_UTID_DIALOG]: 'on',
  [splitConstants.RG_7527_DOMAIN_SWITCH]: 'on',
  [splitConstants.RG_7527_PRE_DOMAIN_SWITCH]: 'on',
  [splitConstants.RG_7460_REMOVE_SIGNUP_SESSION]: 'on'
}
